import { isSqliteMediaType } from "../../shared/fileMediaTypes";

export function mediaTypeLabel(mediaType: string): string {
  const type = mediaType.split(";", 1)[0]!.trim().toLowerCase();
  if (isSqliteMediaType(type)) return "SQLite database";

  switch (type) {
    case "application/pdf":
      return "PDF document";
    case "application/zip":
    case "application/x-zip-compressed":
      return "ZIP archive";
    case "application/json":
      return "JSON";
    case "application/msword":
    case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
      return "Word document";
    case "application/vnd.ms-excel":
    case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
      return "Excel spreadsheet";
    case "image/png":
      return "PNG image";
    case "image/jpeg":
      return "JPEG image";
    case "image/gif":
      return "GIF image";
    case "image/webp":
      return "WebP image";
    case "text/plain":
      return "Plain text";
    case "text/markdown":
      return "Markdown";
    case "text/csv":
      return "CSV";
    case "text/html":
      return "HTML";
    case "application/octet-stream":
      return "File";
    default:
      return type;
  }
}
